import { InputFieldDirectiveModule } from '@b2b/common/directives/inputField/inputField';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { UserPreferencesService } from '@b2b/common/services/userPreferences/types';
import { TODO } from '@b2b/types/core';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';

interface AccountCompanyModel {
  tenant: TODO;
}

export const AccountCompanyControllerModule = angular
  .module('acme.view.application.account.company.controllers', [
    'acme.common.service.api',
    'acme.common.service.auth',
    'acme.common.service.helpers',
    'acme.common.service.validate',
    'acme.common.service.permissions',
    'acme.common.factory.notice',
    InputFieldDirectiveModule,
    'acme.common.service.userPreferences',
  ])
  .controller('AccountCompanyController', [
    '$scope',
    '$log',
    '$timeout',
    'AuthService',
    'ApiService',
    'HelpersService',
    'NoticeFactory',
    'ValidateService',
    function AccountCompanyController(
      $scope: IScope & { accountCompany: TODO; noticeTimer: TODO },
      $log: TODO,
      $timeout: ITimeoutService,
      AuthService: TODO,
      ApiService: ApiService,
      HelpersService: TODO,
      NoticeFactory: NoticeFactory,
      ValidateService: TODO,
    ) {
      const ctrl = {
        model: { tenant: {} } as AccountCompanyModel,

        countries: [
          { name: 'United States', alpha2Code: 'US', alpha3Code: 'USA' },
          { name: 'Canada', alpha2Code: 'CA', alpha3Code: 'CAN' },
          { name: 'New Zealand', alpha2Code: 'NZ', alpha3Code: 'NZL' },
          { name: 'Other', alpha2Code: 'OTHER', alpha3Code: 'OTHER' },
        ],

        selectedCountry: {} as Partial<{ name: string }>,

        currentImage: {},
        noticeTimer: {},

        tz: [
          { name: 'New Zealand', label: 'New Zealand Standard Time (NZST)' },
          { name: 'Hawaii', label: 'Hawaii Standard time (HST)' },
          { name: 'Pacific', label: 'Pacific Standard Time (PST)' },
          { name: 'Eastern', label: 'Eastern Standard Time (EST)' },
          { name: 'Central', label: 'Central Standard Time (CST)' },
          { name: 'Mountain', label: 'Mountain Time (MST/MDT)' },
          { name: 'Arizona', label: 'Arizona (America/Phoenix)' },
          { name: 'UK', label: 'UK (GMT/BST)' },
          { name: 'Ireland', label: 'Ireland (GMT/IST)' },
          { name: 'WesternEuropean', label: 'Western European Time (WET/WEST)' },
          { name: 'CentralEuropean', label: 'Central European Time (CET/CEST)' },
          { name: 'EasternEuropean', label: 'Eastern European Time (EET/EEST)' },
        ],

        selectedTZ: {} as Partial<{ name: string }>,

        notice: new NoticeFactory(),

        init: function () {
          $scope.$emit('Application::contentTitleChange', {
            title: 'Company Profile',
            buttonRight: {
              label: 'Update',
              permissions: ['COMPANY_PROFILE_UPDATE', 'GLOBAL_CALENDAR_UPDATE'],
              action: function () {
                ctrl.prepare();
              },
            },
          });
          $scope.$on('upload::done', ctrl.onUploadDone);
          $scope.$on('AccountCompanyHours::complete', ctrl.onAccountCompanyHoursComplete);
          $scope.$on('upload::error', ctrl.onUploadError);
          ctrl.getTenant(AuthService.getCookie('user').tenantId);
        },

        prepare: function () {
          $scope.$broadcast('AccountCompany::complete');
        },

        complete: function () {
          if (
            ValidateService.validate([
              { len: { value: ctrl.model.tenant.city } },
              { len: { value: ctrl.model.tenant.streetAddress1 } },
              { len: { value: ctrl.model.tenant.name } },
            ])
          ) {
            ctrl.notice.hideSuccessMessages();
            ctrl.notice.hideErrorMessages();
            ApiService.tenant.update(ctrl.model.tenant).then(ctrl.success.complete, ctrl.error.complete);
          } else {
            ctrl.notice.showErrorMessages([{ message: 'Please correct the errors below.' }]);
          }
        },

        getConsumerLink: function () {
          return ctrl.model.tenant.consumerPage + '/list';
        },

        getTenant: function (id) {
          ApiService.tenant.view().then(ctrl.success.getTenant, ctrl.error.getTenant);
        },

        isValidPhone: function () {
          if (ctrl.notice.isLoaded) {
            return ValidateService.validate([{ phone: ctrl.model.tenant.phoneNumber }]);
          }
        },

        isValidCity: function () {
          return ctrl.isValidLen(ctrl.model.tenant.city);
        },

        isValidStreet: function () {
          return ctrl.isValidLen(ctrl.model.tenant.streetAddress1);
        },

        isValidCompanyName: function () {
          if (ctrl.notice.isLoaded) {
            if (!ctrl.isValidLen(ctrl.model.tenant.name)) {
              return false;
            }
          }

          return true;
        },

        isValidName: function (value) {
          let r;

          if (ctrl.notice.isLoaded) {
            r = ValidateService.validate([{ name: ctrl.model.tenant.name }]);
          } else {
            // Don't test undefined values
            r = true;
          }

          return r;
        },

        isValidLen: function (value) {
          let r;

          if (ctrl.notice.isLoaded) {
            r = ValidateService.validate([{ len: { value: value } }]);
          } else {
            // Don't test undefined values
            r = true;
          }

          return r;
        },

        removeLogoImage: function () {
          $scope.$broadcast('upload::delete', ctrl.currentImage);
          ctrl.model.tenant.logoImage = null;
          delete ctrl.model.tenant.logoImage;
          ctrl.complete();
        },

        onUploadDone: function (e, data) {
          ctrl.currentImage = data;
          if (data.file) {
            ctrl.model.tenant.logoImage = data.file.thumbnailPath;
          }
          ctrl.complete();
        },

        onUploadError: function (e, data) {
          ctrl.notice.showErrorMessages([{ message: data.result.error || 'There was an error uploading the file.' }]);
        },

        onTimezoneUpdate: function () {
          ctrl.model.tenant.timezone = ctrl.selectedTZ.name;
        },

        onSelectedCountryUpdate: function () {
          if (ctrl.selectedCountry) {
            ctrl.model.tenant.country = ctrl.selectedCountry.name;
          } else {
            ctrl.model.tenant.country = '';
          }
        },

        getCountries: function () {
          ApiService.form.avs.countries().then(ctrl.success.getCountries, ctrl.error.getCountries);
        },

        findCountry: function (name: string) {
          for (let i = 0, ii = ctrl.countries.length; i < ii; i++) {
            if (
              ctrl.countries[i].name === name ||
              ctrl.countries[i].alpha2Code === name ||
              ctrl.countries[i].alpha3Code === name
            ) {
              return {
                index: i,
                country: ctrl.countries[i],
              };
            }
          }

          return false;
        },

        setDefaultCountry: function (country) {
          ctrl.model.tenant.country = country.name;
          ctrl.selectedCountry = country;
        },

        success: {
          complete: function (response) {
            $timeout.cancel($scope.noticeTimer);
            ctrl.notice.showSuccessMessages([{ message: 'Successfully Saved!' }]);

            $scope.noticeTimer = $timeout(() => {
              ctrl.notice.hideSuccessMessages();
            }, 3000);
          },

          getTenant: function (response) {
            ctrl.notice.isLoaded = true;
            ctrl.model.tenant = response.data.tenant;

            for (let i = 0, ii = ctrl.tz.length; i < ii; i++) {
              if (ctrl.tz[i].name === ctrl.model.tenant.timezone) {
                ctrl.selectedTZ = ctrl.tz[i];
                break;
              }
            }
            ctrl.model.tenant.donateURL = ctrl.model.tenant.consumerPage.replace(/events/gi, 'donate');

            ctrl.getCountries();
          },

          getCountries: function (response) {
            ctrl.countries = response.data.payload;

            if (!ctrl.model.tenant.country) {
              ctrl.setDefaultCountry(ctrl.countries[0]);
            } else {
              const found = ctrl.findCountry(ctrl.model.tenant.country);

              if (found) {
                ctrl.selectedCountry = found.country;
                ctrl.model.tenant.country = found.country.name;
              }
            }
          },
        },

        error: {
          complete: function (response) {
            ctrl.notice.showErrorMessages([{ message: response.data.error }]);
          },

          getTenant: function (response) {
            ctrl.notice.showErrorMessages([{ message: response.data.error }]);
          },

          getCountries: function (response) {},
        },

        onAccountCompanyHoursComplete: function (e, data) {
          if (data.valid) {
            ctrl.complete();
          } else {
            ctrl.notice.showErrorMessages([{ message: 'Please correct the errors below.' }]);
          }
        },
      };

      $scope.accountCompany = ctrl;
      ctrl.init();
    },
  ])
  .controller('AccountCompanyHoursController', [
    '$scope',
    '$log',
    '$timeout',
    '$filter',
    'AuthService',
    'ApiService',
    'HelpersService',
    'NoticeFactory',
    'ValidateService',
    function (
      $scope: IScope & { accountCompanyHours: TODO },
      $log: TODO,
      $timeout: ITimeoutService,
      $filter: IFilterService,
      AuthService: TODO,
      ApiService: ApiService,
      HelpersService: TODO,
      NoticeFactory: NoticeFactory,
      ValidateService: TODO,
    ) {
      const ctrl = {
        model: {} as TODO,
        componentType: 'globalCalendar',
        key: '', // calendar key for audit trail
        openDays: [] as TODO[],
        isSubmitted: false,
        standardHours: [
          {
            day: 'Sunday',
            hours: [{ startTime: '', endTime: '', hoursOpen: 0 }],
            closed: false,
          },
          {
            day: 'Monday',
            hours: [{ startTime: '', endTime: '', hoursOpen: 0 }],
            closed: false,
          },
          {
            day: 'Tuesday',
            hours: [{ startTime: '', endTime: '', hoursOpen: 0 }],
            closed: false,
          },
          {
            day: 'Wednesday',
            hours: [{ startTime: '', endTime: '', hoursOpen: 0 }],
            closed: false,
          },
          {
            day: 'Thursday',
            hours: [{ startTime: '', endTime: '', hoursOpen: 0 }],
            closed: false,
          },
          {
            day: 'Friday',
            hours: [{ startTime: '', endTime: '', hoursOpen: 0 }],
            closed: false,
          },
          {
            day: 'Saturday',
            hours: [{ startTime: '', endTime: '', hoursOpen: 0 }],
            closed: false,
          },
        ] as {
          day: string;
          hours: { startTime: Date | string; endTime: Date | string; hoursOpen?: number }[];
          closed: boolean;
        }[],

        exceptions: [] as { name: TODO; date: TODO; startTime: TODO; endTime: TODO; closed: TODO }[],

        init: function () {
          console.log('AccountCompanyHours::init');
          ctrl.getHours();
          $scope.$on('AccountCompany::complete', ctrl.onAccountCompanyComplete);
        },

        initStartTimes: function () {
          const times = ctrl.getInitTimes();

          for (let i = 0, ii = ctrl.standardHours.length; i < ii; i++) {
            for (let j = 0, jj = ctrl.standardHours[i].hours.length; j < jj; j++) {
              ctrl.standardHours[i].hours[j].startTime = times.startTime;
              ctrl.standardHours[i].hours[j].endTime = times.endTime;
              ctrl.updateHoursOpen(ctrl.standardHours[i].hours[j]);
            }
          }
        },

        getInitTimes: function () {
          const endDate = new Date();
          const startDate = new Date();

          startDate.setHours(9);
          startDate.setMinutes(0);
          startDate.setSeconds(0);
          startDate.setMilliseconds(0);
          const startTime = startDate;

          endDate.setHours(17);
          endDate.setMinutes(0);
          endDate.setSeconds(0);
          endDate.setMilliseconds(0);
          const endTime = endDate;

          return {
            startTime: startTime,
            endTime: endTime,
          };
        },

        addTime: function (hour, hourIndex) {
          console.log('addTime', hourIndex);

          const endTime = hour.hours[hourIndex].endTime;
          const time = {
            startTime: '' as Date | string,
            endTime: '' as Date | string,
            hoursOpen: 0,
          };

          // If the day is closed perform no actions
          if (hour.closed) {
            return;
          }

          time.startTime = new Date();
          time.startTime.setHours(endTime.getHours());
          time.startTime.setMinutes(endTime.getMinutes());

          time.endTime = new Date();
          time.endTime.setHours(endTime.getHours() + 1);
          time.endTime.setMinutes(endTime.getMinutes());

          ctrl.updateHoursOpen(time);

          hour.hours.push(time);

          ctrl.update();
        },

        removeTime: function (hour, hourIndex) {
          // If the day is closed perform no actions
          if (hour.closed) {
            return;
          }

          hour.hours.splice(hourIndex, 1);

          ctrl.update();
        },

        addException: function () {
          const times = ctrl.getInitTimes();
          ctrl.exceptions.unshift({
            name: '',
            date: new Date(),
            startTime: times.startTime,
            endTime: times.endTime,
            closed: true,
          });
          ctrl.update();
        },

        removeException: function (index) {
          ctrl.exceptions.splice(index, 1);
          ctrl.update();
        },

        isValidName: function (name) {
          return ValidateService.validate({
            len: { value: name },
          });
        },

        getHours: function () {
          ApiService.tenant.calendar.detail().then(ctrl.success.getHours, ctrl.error.getHours);
        },

        toggleClosed: function (hour) {
          hour.closed = !hour.closed;
          ctrl.update();
        },

        updateHoursOpen: function (hour) {
          const diff = hour.endTime.getTime() - hour.startTime.getTime();

          hour.hoursOpen = (diff / (1000 * 60 * 60)) % 24;
        },

        updateHourSlot: function (hour) {
          ctrl.updateHoursOpen(hour);
          ctrl.update();
        },

        update: function () {
          ctrl.updateStandardHours();
          ctrl.updateExceptions();
        },

        updateStandardHours: function () {
          const r: { hours: string[]; weekdays: TODO[] }[] = [];

          for (let i = 0, ii = ctrl.standardHours.length; i < ii; i++) {
            if (!ctrl.standardHours[i].closed) {
              const time = {
                hours: [] as string[],
                weekdays: [ctrl.standardHours[i].day],
              };

              for (let j = 0, jj = ctrl.standardHours[i].hours.length; j < jj; j++) {
                time.hours.push(
                  $filter('date')(ctrl.standardHours[i].hours[j].startTime, 'HH:mm') +
                    '-' +
                    $filter('date')(ctrl.standardHours[i].hours[j].endTime, 'HH:mm'),
                );
              }

              r.push(time);
            }
          }

          ctrl.model.standard = r;
          console.log('AccountCompanyHoursController::update', ctrl.model);
        },

        updateExceptions: function () {
          const r: { name: string; hours: string[]; date: string }[] = [];

          for (let i = 0, ii = ctrl.exceptions.length; i < ii; i++) {
            const time = {
              name: ctrl.exceptions[i].name,
              hours: ['closed'],
              date: $filter('date')(ctrl.exceptions[i].date, 'yyyy-MM-dd'),
            };

            if (!ctrl.exceptions[i].closed) {
              time.hours = [
                $filter('date')(ctrl.exceptions[i].startTime, 'HH:mm') +
                  '-' +
                  $filter('date')(ctrl.exceptions[i].endTime, 'HH:mm'),
              ];
            }

            r.push(time);
          }

          ctrl.model.exceptions = r;
          console.log('AccountCompanyHoursController::update', ctrl.model);
        },

        extractDate: function (dateString) {
          const split = dateString.split('-');
          return new Date(split[0], parseInt(split[1], 10) - 1, split[2]);
        },

        extractStartEndTime: function (range) {
          const split = range.split('-');
          const startHour = split[0].split(':')[0];
          const startMinute = split[0].split(':')[1];
          const endHour = split[1].split(':')[0];
          const endMinute = split[1].split(':')[1];
          const startTime = new Date();
          const endTime = new Date();

          startTime.setHours(parseInt(startHour, 10));
          startTime.setMinutes(parseInt(startMinute, 10));

          endTime.setHours(parseInt(endHour, 10));
          endTime.setMinutes(parseInt(endMinute, 10));

          return {
            startTime: startTime,
            endTime: endTime,
          };
        },

        checkOpenDays: function () {
          for (let i = 0, ii = ctrl.standardHours.length; i < ii; i++) {
            if (ctrl.openDays.indexOf(ctrl.standardHours[i].day) === -1) {
              const times = ctrl.getInitTimes();
              ctrl.standardHours[i].hours[0].startTime = times.startTime;
              ctrl.standardHours[i].hours[0].endTime = times.endTime;
              ctrl.standardHours[i].closed = true;
            }
          }
        },

        validateCompanyHours: function () {
          let r = true;

          if (ctrl.standardHours instanceof Array) {
            outer: for (let i = 0, ii = ctrl.standardHours.length; i < ii; i++) {
              if (ctrl.standardHours[i].hours instanceof Array) {
                for (let j = 0, jj = ctrl.standardHours[i].hours.length; j < jj; j++) {
                  if (
                    (ctrl.standardHours[i].hours[j].startTime as Date).getTime() >=
                    (ctrl.standardHours[i].hours[j].endTime as Date).getTime()
                  ) {
                    r = false;
                    break outer;
                  }
                }
              }
            }
          }

          return r;
        },

        validateExceptions: function () {
          if (Array.isArray(ctrl.exceptions)) {
            for (let i = 0, ii = ctrl.exceptions.length; i < ii; i++) {
              if (ctrl.exceptions[i].startTime.getTime() >= ctrl.exceptions[i].endTime.getTime()) {
                return false;
              }
            }
          }

          return true;
        },

        process: function () {
          if (ctrl.model.hasOwnProperty('standard')) {
            for (let i = 0, ii = ctrl.model.standard.length; i < ii; i++) {
              // Move data from the model to our UI data structure
              for (let j = 0, jj = ctrl.standardHours.length; j < jj; j++) {
                if (ctrl.standardHours[j].day === ctrl.model.standard[i].weekdays[0]) {
                  // save open days for UI
                  console.log(ctrl.standardHours[j].day, ctrl.model.standard[i].weekdays[0]);
                  ctrl.openDays.push(ctrl.model.standard[i].weekdays[0]);
                  ctrl.processHours(i, j);
                  break;
                }
              }
            }
          }

          ctrl.checkOpenDays();
        },

        processHours: function (modelIndex, standardHoursIndex) {
          // Make our standardHours just as long as hour incoming hours
          ctrl.standardHours[standardHoursIndex].hours = [];

          for (let i = 0, ii = ctrl.model.standard[modelIndex].hours.length; i < ii; i++) {
            ctrl.standardHours[standardHoursIndex].hours.push(
              ctrl.extractStartEndTime(ctrl.model.standard[modelIndex].hours[i]),
            );
          }
        },

        processExceptions: function () {
          let times;
          let closed;

          if (ctrl.model.hasOwnProperty('exceptions')) {
            for (let i = 0, ii = ctrl.model.exceptions.length; i < ii; i++) {
              if (ctrl.model.exceptions[i].hours[0] === 'closed') {
                times = ctrl.getInitTimes();
                closed = true;
              } else {
                times = ctrl.extractStartEndTime(ctrl.model.exceptions[i].hours[0]);
                closed = false;
              }

              ctrl.exceptions.push({
                name: ctrl.model.exceptions[i].name,
                date: ctrl.extractDate(ctrl.model.exceptions[i].date),
                startTime: times.startTime,
                endTime: times.endTime,
                closed: closed,
              });
            }
          }
        },

        hasValidHours: function (hours) {
          return hours && hours.startTime && hours.endTime && hours.startTime.getTime() >= hours.endTime.getTime();
        },

        complete: function () {
          ctrl.isSubmitted = true;

          if (
            AuthService.hasPermission('GLOBAL_CALENDAR_UPDATE') &&
            ctrl.validateCompanyHours() &&
            ctrl.validateExceptions()
          ) {
            ctrl.update();
            ApiService.tenant.calendar.update(ctrl.model).then(ctrl.success.complete, ctrl.error.complete);
          } else {
            ctrl.isSubmitted = false;
            $scope.$emit('AccountCompanyHours::complete', { valid: false });
          }
        },

        success: {
          getHours: function (response) {
            ctrl.model = response.data.payload;
            ctrl.key = response.data.payload.id;

            if (ctrl.model.hasOwnProperty('standard')) {
              ctrl.process();
            } else {
              ctrl.initStartTimes();
            }

            if (ctrl.model.hasOwnProperty('exceptions')) {
              ctrl.processExceptions();
            }
          },
          complete: function (response) {
            if (response.data.payload.id) {
              ctrl.model.id = response.data.payload.id;
            }
            $scope.$emit('AccountCompanyHours::complete', { valid: true });
            ctrl.isSubmitted = false;
          },
        },

        error: {
          getHours: function (response) {},

          complete: function (response) {
            $scope.$emit('AccountCompanyHours::complete', { valid: false });
            ctrl.isSubmitted = false;
          },
        },

        onAccountCompanyComplete: function () {
          ctrl.complete();
        },
      };

      $scope.accountCompanyHours = ctrl;
      ctrl.init();
    },
  ])
  .controller('AccountCompanyHoursDatePickerController', [
    '$scope',
    'UserPreferencesService',
    '$timeout',
    function AccountCompanyHoursDatePickerController(
      $scope: IScope & {
        accountCompanyHoursDatePicker: TODO;
        dt: Date | null;
        format: string;
        formats: string[];
        maxDate: Date;
        minDate: Date;
      },
      UserPreferencesService: UserPreferencesService,
      $timeout: ITimeoutService,
    ) {
      const ctrl = {
        dt: null as Date | null,
        isOpen: false,

        dateOptions: {
          formatYear: 'yy',
          startingDay: UserPreferencesService.getStartDayOfWeek(),
          formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
          showWeeks: false,
        } as {
          formatYear: string;
          startingDay: TODO;
          formatDayTitle: TODO;
          showWeeks?: boolean;
        },

        dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),

        isPreferenceLoaded: false,

        init: function () {
          console.log('AccountCompanyHoursDatePicker::init');
          ctrl.today();
          $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
          $scope.format = $scope.formats[1];
          $scope.minDate = ctrl.getMinDate();
          $scope.maxDate = ctrl.getMaxDate();
          $scope.$on('UserPreferencesService:onDateFormatLoad', ctrl.onDateFormatLoad);
          $timeout(() => {
            $scope.accountCompanyHoursDatePicker.isPreferenceLoaded = true;
          }, 0);
        },

        today: function () {
          ctrl.dt = new Date();
        },

        clear: function () {
          $scope.dt = null;
        },

        getMinDate: function () {
          const d = new Date();

          d.setMonth(0);
          d.setDate(1);

          return d;
        },

        getMaxDate: function () {
          const d = new Date();

          d.setMonth(11);
          d.setDate(31);

          return d;
        },

        open: function ($event) {
          $event.preventDefault();
          $event.stopPropagation();

          $scope.minDate = ctrl.getMinDate();
          $scope.maxDate = ctrl.getMaxDate();

          ctrl.isOpen = true;
        },
        onDateFormatLoad: function (e, data) {
          ctrl.dateFormat = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
          ctrl.dateOptions = {
            formatYear: 'yy',
            startingDay: UserPreferencesService.getStartDayOfWeek(),
            formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
          };
        },
      };

      $scope.accountCompanyHoursDatePicker = ctrl;
      ctrl.init();
    },
  ]).name;
